import { IComponentOptions } from "angular";
import { RoleDetailPermissionsComponentController } from "./controller";

export const vsComponentName = "roleDetailPermissionsComponent";

export const roleDetailPermissionsComponentOptions: IComponentOptions = {
  controller: RoleDetailPermissionsComponentController,
  controllerAs: "roleDetailPermissionsComponentController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    role: "<",
    permissions: "<",
  },
};
